// Migrated
<template>
  <p
    v-if="adultsOnlyWithKids"
    class="text-center font-bold text-black"
    data-i18n="charterDealFinderAdultsOnly"
  >
    {{ $t('charterDealFinderAdultsOnly') }}
  </p>
</template>

<script>
import { mapState } from 'pinia'

export default defineNuxtComponent({
  data () {
    return {
      hotelIsAdultsOnly: false,
    }
  },

  computed: {
    ...mapState(useDealfinderStore, ['hotel']),
    ...mapState(useCharterPackagesStore, {
      peoplePerRoom: 'peoplePerRoom',
    }),

    adultsOnlyWithKids () {
      if (this.hotelIsAdultsOnly && this.peoplePerRoom?.children > 0) {
        return true
      }

      return false
    },
  },

  watch: {
    hotel () {
      if (!this.hotel) {
        return false
      }
      this.checkHotelForAdultsOnly()
    },
  },

  mounted () {
    this.checkHotelForAdultsOnly()
  },

  methods: {
    checkHotelForAdultsOnly () {
      if (!this.hotel) {
        this.hotelIsAdultsOnly = false
        return
      }
      const sections = this.hotel?.factsheet?.sections || []
      const buildingInfo = sections.find(item => item?.type === 1003 || item?.name === 'building_info')
      if (buildingInfo) {
        const adultsOnlyFact = (buildingInfo?.facts || []).find(item => item?.type === 2251 || item?.name === 'hoteltype_adultsonly')

        if (adultsOnlyFact) {
          this.hotelIsAdultsOnly = adultsOnlyFact?.value === 'true' || adultsOnlyFact?.value === true
          return
        }
      }

      this.hotelIsAdultsOnly = false
    },

  },
})
</script>
